// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"224":"9d7604d2","261":"06c5e9ac","682":"4a14f09e"}[chunkId] + ".css";
};